'use client';

import { TReview } from '@/types';
import Rate from 'rc-rate';

interface ISingleReview {
  review: TReview;
}

export const SingleReview = ({ review }: ISingleReview) => {
  return (
    <div className="flex flex-col gap-2">
      <h4>{review.userName}</h4>
      <p>{review.description}</p>
      <Rate count={5} value={review.grade} defaultValue={5} allowHalf={true} disabled={true} />
    </div>
  );
};
